import { useState, useEffect, Fragment } from 'react';
import { useNavigate } from 'react-router';
import forwardArrow from '../../../assets/icons/forward.svg';
import { playSong } from '../../common/actions/common.actions';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { selectLoginData } from "../login/login.actions";
import Modal from '../../common/components/modal';
import { IoIosArrowBack } from "react-icons/io";
import { useTranslation } from "react-i18next";
import transactionService from '../../../api/services/transactionService';
import Deposite from './deposite';
import Withdrawal from './withdrawal';

const Transactions = ({ setIsLoading }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userDetails } = useSelector(selectLoginData);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [message, setMessage] = useState('Process Successfully');
    const [accountList, setAccountList] = useState([]);
    const [activeTab, setActiveTab] = useState('deposite'); 
    const [loading,setLoading] = useState(false);

    useEffect(() => {
        fetchAccountList()
    }, [])

    const fetchAccountList = async () => {
        try {
            setLoading(true);
            const response = await transactionService.getPaymentAccountList();
            const data = await response.json();

            if (data) {
                setAccountList(data);
            }
        } catch (error) {
            console.error("API request error:", error);
        } finally {
            setLoading(false);
        }
    }

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleSongClick = async () => {
        dispatch(playSong());
      };

    const handleClick = () => {
        handleSongClick();
        navigate('/dashboard');
      };

    return (
        <div className="flex h-[100dvh] flex-col w-full items-center bg-white/90 backdrop-blur-xl dark:bg-gray-900/90 font-dangrek">
            <div className="w-full flex justify-between items-center text-center py-2 pr-5 border-b border-gray-200/30 dark:border-gray-700/30 bg-white/90 backdrop-blur-xl dark:bg-gray-900/90">
                <div className="flex items-center pr-2">
                    <button
                        className="top-3 left-3 w-10 h-10 mr-3
                      rounded-full drop-shadow-lg flex justify-center items-center text-gray-700 dark:text-white text-4xl"
                      onClick={handleClick}
                    >
                        {/* <img src={forwardArrow} alt="Back Arrow" /> */}
                        <IoIosArrowBack size={25} className="text-gray-700 dark:text-white" />
                    </button>
                    <h3 className="text-gray-700 dark:text-white text-lg ml-3 text-center font-dangrek">
                        {t("transaction")}
                    </h3>
                </div>
            </div>
            <div className="flex flex-col items-center justify-center bg-white/90 backdrop-blur-xl dark:bg-gray-900/90 flex-1">
                <div className="flex space-x-1 my-4">
                    <button className={`group py-2 px-3 rounded-l-lg border-2 border-blue-500 transition-all duration-300 hover:bg-blue-500 hover:text-white
                    ${activeTab === 'deposite'
                            ? 'bg-blue-500 text-white'
                            : 'bg-white/90 backdrop-blur-xl dark:bg-gray-900/90 text-blue-500'
                        }`}
                        onClick={() => setActiveTab('deposite')}
                    >
                        <span
                            className={`group-hover:text-white text-sm transition-colors ${activeTab === 'deposite' ? 'text-white' : 'text-blue-500'
                                }`}
                        >
                             {t("deposite")}
                        </span>
                    </button>

                    <button className={`group py-2 px-3 rounded-r-lg border-2 border-blue-500 transition-all duration-300 hover:bg-blue-500 hover:text-white
                    ${activeTab === 'withdraw'
                            ? 'bg-blue-500 text-white'
                            : 'bg-white/90 backdrop-blur-xl dark:bg-gray-900/90 text-blue-500'
                        }
                    `}
                        onClick={() => setActiveTab('withdraw')}
                    >
                        <span
                            className={`group-hover:text-white text-sm transition-colors ${activeTab === 'withdraw' ? 'text-white' : 'text-blue-500'
                                }`}
                        >
                             {t("withdraw")}
                        </span>
                    </button>
                </div>
                {
                    activeTab === "deposite" ? 
                    <Deposite 
                    accountList={accountList} 
                    t={t} 
                    loading={loading} 
                    userDetails={userDetails} 
                    setIsLoading={setIsLoading}
                    setIsModalOpen={setIsModalOpen}
                    setMessage={setMessage}
                    handleSongClick={handleSongClick}
                    /> 
                    : <Withdrawal 
                    t={t} 
                    userDetails={userDetails} 
                    setIsLoading={setIsLoading}
                    setIsModalOpen={setIsModalOpen}
                    setMessage={setMessage}
                    handleSongClick={handleSongClick}
                    />
                }
            </div>
            {isModalOpen && (
                <Modal title="EP SPORTS" content={message} onClose={closeModal} />
            )}
        </div>
    );
};

export default Transactions;


